<script setup></script>

<template>
	<section class="artist-clips">
		<div class="artist-clips__container">
			<div class="artist-clips__wrapper">
				<div class="artist-clips__title artist-clips__title-1">
					<h2><span>Артисты из чартов</span> снимают клипы в наших масках</h2>
					<p>
						Мы врываемся в топ-стримы <br />
						Twitch и TikTok
					</p>
				</div>

				<div class="artist-clips__img artist-clips__img-1">
					<img
						loading="lazy"
						src="@/assets/img/artist-clips/artist-clips_img-1.png"
						alt=""
					/>
				</div>

				<div class="artist-clips__title artist-clips__title-2">
					<h3>Некоторые маски доходят <span>до самих героев</span></h3>
				</div>

				<div class="artist-clips__img artist-clips__img-2">
					<img
						loading="lazy"
						src="@/assets/img/artist-clips/artist-clips_img-2.gif"
						alt=""
					/>
				</div>

				<div class="artist-clips__title artist-clips__title-3">
					<p>Нас чуть не запретили — это был лучший отзыв</p>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.artist-clips {
	padding: 6.7rem 0 35rem;
	position: relative;

	@media (max-width: 991.98px) {
		padding-top: 3.1rem;
		padding-bottom: 4rem;
	}

	// .artist-clips__container
	&__container {
	}

	// .artist-clips__wrapper
	&__wrapper {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		@media (max-width: 991.98px) {
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
	}

	// .artist-clips__title
	&__title {
		text-align: left;

		h2 {
			@media (min-width: 991.98px) {
				text-align: left;
			}
		}
	}

	// .artist-clips__title-1
	&__title-1 {
		max-width: 68.9rem;

		@media (min-width: 991.98px) {
			padding-top: 4.1rem;
		}

		p {
			margin-top: 2.2rem;

			@media (max-width: 991.98px) {
				margin-top: 1rem;
				text-align: center;
			}
		}
	}

	// .artist-clips__title-2
	&__title-2 {
		@media (min-width: 991.98px) {
			max-width: 50.1rem;
			position: absolute;
			bottom: 11.2rem;
			left: 59.1rem;
			transform: rotate(8deg);
		}

		@media (max-width: 991.98px) {
			transform: rotate(-7deg);
			margin-top: 4.2rem;
			text-align: left;
			max-width: 31.1rem;
		}
	}

	// .artist-clips__title-3
	&__title-3 {
		@media (min-width: 991.98px) {
			max-width: 41.1rem;
			position: absolute;
			bottom: 18.3rem;
			right: 29.3rem;
			transform: rotate(-10deg);
		}

		@media (max-width: 991.98px) {
			transform: rotate(4deg);
			margin-top: 2.4rem;
			margin-left: -1.4rem;
			max-width: 22.8rem;
		}
	}

	// .artist-clips__img
	&__img {
		width: 100%;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	// .artist-clips__img-1
	&__img-1 {
		max-width: 98rem;

		@media (max-width: 991.98px) {
			margin-top: 1.8rem;
			max-width: 32rem;
		}
	}

	// .artist-clips__img-2
	&__img-2 {
		max-width: 43rem;
		max-height: 53.5rem;
		border-radius: 2.8rem;
		overflow: hidden;

		@media (max-width: 991.98px) {
			border-radius: 1rem;
			max-width: 15.3rem;
			max-height: 19rem;
			margin-top: 3.3rem;
		}

		@media (min-width: 991.98px) {
			position: absolute;
			bottom: -1.5rem;
			left: 8rem;
		}
	}
}
</style>
